
  var style = require("icon-maker-loader/.tmp/28e27980-db16-4011-8a4d-a9e26dfc90be/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-arrow-med-down"];
  } else {
    module.exports = "icon-maker icon-maker-arrow-med-down";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-med-down.svg
// module id = 533
// module chunks = 5